<template>
    <div class="error-msg-wrap">
        <div v-if="loaded" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>Name</h3>
            <input type="text" v-model="formData.Name" />
            <draggable :list="formData.FieldsJSON">
                <div v-for="(field, i) in formData.FieldsJSON" :key="i" class="edit-form-field">
                    <div class="form-close">
                        <svg @click="removeField(i)" fill="red" style="width:18px;height:18px" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z"/></svg>
                    </div>
                    <input v-if="field.type != 'textblock' && field.type != 'image'" type="text" placeholder="Question" v-model="field.label" />
                    <input v-if="field.type != 'textblock' && field.type != 'image'" type="text" placeholder="Optional Description" v-model="field.description" />
                    <select v-model="field.type">
                        <option value="text">Text</option>
                        <option value="textarea">Multi-line Text</option>
                        <option value="date">Date</option>
                        <option value="time">Time</option>
                        <option value="select">Select</option>
                        <option value="location">Location</option>
                        <option value="file">File</option>
                        <option value="multiplefiles">Multiple Files</option>
                        <option value="signature">Signature (Drawing)</option>
                        <option value="textblock">Text Block (Display)</option>
                        <option value="image">Image (Display)</option>
                    </select>
                    <div v-if="field.type == 'select'" class="edit-form-field">
                        <draggable :list="field.options">
                            <div v-for="(option, j) in field.options" :key="'o'+j" style="position:relative">
                                <input style="padding:5px 0;border:0;margin:0" type="text" v-model="field.options[j]" />
                                <div class="form-close">
                                    <svg-icon @click="removeOption(field.options, j)" style="color:red;width:12px;height:12px" icon="x" />
                                </div>
                            </div>
                        </draggable>
                        <form @submit.prevent="addOption(field)" style="display:flex;margin:5px 0">
                            <input style="flex:1;margin-bottom:0" type="text" v-model="field.optionInput" placeholder="Add Option" />
                            <button class="add-btn">Add</button>
                        </form>
                    </div>
                    <div v-else-if="field.type == 'textblock'">
                        <tip-tap v-model="field.textBlock" />
                    </div>
                    <div v-else-if="field.type == 'image'">
                        <drop-file @fileChange="onImageChange($event, field)" :imageOnly="true" />
                        <img v-if="field.imageURL" style="margin-top:10px" :src="field.imageURL" />
                    </div>
                    <div v-if="field.type != 'textblock' && field.type != 'image'" class="checkbox-input" style="margin-top:10px">
                        <input type="checkbox" v-model="field.required" />
                        <div>Required</div>
                    </div>
                    <div v-if="field.type != 'textblock' && field.type != 'image'" class="checkbox-input" style="margin-top:10px">
                        <input type="checkbox" v-model="field.sensitive" />
                        <div>Sensitive Information</div>
                    </div>
                    <div class="checkbox-input" style="margin-top:10px">
                        <input type="checkbox" v-model="field.conditional" />
                        <div>Show Conditionally</div>
                    </div>
                    <div v-if="field.conditional">
                        <input type="text" placeholder="Field Label" v-model="field.conditionalField" />
                        <div style="margin:10px">Is Equal To</div>
                        <div class="edit-form-field">
                            <div>
                                <div v-for="(option, j) in field.conditionalValuesArray" :key="'o'+j" style="position:relative">
                                    <input style="padding:5px 0;border:0;margin:0" type="text" v-model="field.conditionalValuesArray[j]" />
                                    <div class="form-close">
                                        <svg-icon @click="removeOption(field.conditionalValuesArray, j)" style="color:red;width:12px;height:12px" icon="x" />
                                    </div>
                                </div>
                            </div>
                            <form @submit.prevent="addConditionalValue(field)" style="display:flex;margin:5px 0">
                                <input style="flex:1;margin-bottom:0" type="text" v-model="field.conditionalValueInput" placeholder="Add Value" />
                                <button class="add-btn">Add</button>
                            </form>
                        </div>
                    </div>
                </div>
            </draggable>
            <div style="display:flex">
                <div @click="addItem()" class="add-btn">Add Item</div>
            </div>
            <div style="margin-top:25px">
                <form @submit.prevent="addRecipient()" style="display:flex;margin-bottom:5px">
                    <input style="flex:1;margin-bottom:0" type="text" v-model="recipientInput" placeholder="Add Email Recipient" />
                    <button class="add-btn">Add</button>
                </form>
                <div style="margin-top:20px">
                    <div v-for="(recipient, j) in formData.RecipientsJSON" :key="'r'+j" style="position:relative;margin-bottom:5px">
                        <div>{{ recipient }}</div>
                        <div class="form-close">
                            <svg-icon @click="removeRecipient(j)" style="color:red;width:12px;height:12px" icon="x" />
                        </div>
                    </div>
                </div>
                
            </div>
            <input style="margin-top:25px" :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import { VueDraggableNext } from 'vue-draggable-next';
import SvgIcon from './SvgIcon.vue';
import TipTap from './TipTap.vue';
import DropFile from './DropFile.vue';

export default defineComponent({
    name: 'AddEditForm',
    props: [ 'formToEdit' ],
    components: {
        draggable: VueDraggableNext,
        SvgIcon,
        TipTap,
        DropFile
    },
    data() {
        return {
            disableButton: false,
            formData: {
                Name: '',
                FieldsJSON: [] as any,
                CompanyID: this.$store.state.user.companyID,
                RecipientsJSON: [] as any
            },
            loaded: false,
            recipientInput: ''
        }
    },
    async created() {
        if(this.formToEdit) {
            await axios.get(`${this.$store.state.apiUrl}/api/forms/${this.formToEdit}`)
                .then(resp => {
                    resp.data.FieldsJSON = JSON.parse(resp.data.FieldsJSON);
                    for(const field of resp.data.FieldsJSON) {
                        if(field.conditionalValues) {
                            field.conditionalValuesArray = field.conditionalValues.split(';');
                        }
                    }
                    resp.data.RecipientsJSON = JSON.parse(resp.data.RecipientsJSON);
                    this.formData = resp.data;
                    console.log(this.formData);
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })
        }

        this.loaded = true;
    },
    methods: {
        async submit() {
            if(!this.formData.Name) {
                alert('Name cannot be blank');
                return;
            }

            if(!this.formData.FieldsJSON.length) {
                alert('Must include fields');
                return;
            }

            for(const field of this.formData.FieldsJSON) {
                if(field.type == 'image') {
                    if(!field.imageURL) {
                        alert('Include display image or remove image field');
                        return;
                    }
                } else if(field.type == 'textblock') {
                    field.required = false;
                    if(!field.textBlock) {
                        alert('Include text for text block');
                        return;
                    }
                } else {
                    if(!field.label) {
                        alert('Field must have question');
                        return;
                    } else {
                        field.label = field.label.trim();
                    }
                }
                
                field.optionInput = '';
                field.conditionalValueInput = '';
                if(field.conditionalValuesArray) {
                    field.conditionalValues = field.conditionalValuesArray.join(';');
                }
            }

            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/forms`, this.formData)
                .then(resp => {
                    this.$emit('close');
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })

            this.disableButton = false;
        },
        addItem() {
            this.formData.FieldsJSON.push({
                label: '',
                type: 'text',
                required: false,
                options: []
            })
        },
        removeField(i: number) {
            this.formData.FieldsJSON.splice(i, 1);
        },
        addOption(field: any) {
            if(!field.optionInput) {
                return;
            }
            field.options.push(field.optionInput.trim());
            field.optionInput = '';
            this.$forceUpdate();
        },
        addConditionalValue(field: any) {
            if(!field.conditionalValueInput) {
                return;
            }
            if(!field.conditionalValuesArray) {
                field.conditionalValuesArray = [];
            }
            field.conditionalValuesArray.push(field.conditionalValueInput.replace(/;/g, '').trim());
            field.conditionalValueInput = '';
            this.$forceUpdate();
        },
        removeOption(options: any, j: number) {
            options.splice(j, 1);
            this.$forceUpdate();
        },
        addRecipient() {
            if(!this.recipientInput) {
                return;
            }
            const recipientFormatted = this.recipientInput.toLowerCase().trim();
            if(!recipientFormatted.includes('@') || !recipientFormatted.includes('.')) {
                alert('Enter a valid email');
                return;
            }
            this.formData.RecipientsJSON.push(recipientFormatted);
            this.recipientInput = '';
        },
        removeRecipient(j: number) {
            this.formData.RecipientsJSON.splice(j, 1);
        },
        async onImageChange(file: any, field: any) {
            if(file) {
                this.disableButton = true;
                const formData = new FormData();
                formData.append('file', file);
                await axios.post(`${this.$store.state.apiUrl}/api/playbook/processimage`, formData)
                    .then(resp => {
                        field.imageURL = this.$store.state.spacesUrl + resp.data.key;
                    })
                    .catch(e => {
                        console.log(e);
                        alert("There was an error.");
                    })
                this.disableButton = false;
            }
        }
    }
});
</script>
